import styled from 'styled-components';
import { Button, Container } from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { AttachMoney, AccessTime, Event, NotificationsOutlined } from '@mui/icons-material';

export const BasicContainer = styled(Container)`
    overflow: auto;
    height: 100%;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 12px;

    > * {
        margin-bottom: 4px;
    }

    @media (max-width: 768px) {
        gap: 8px;
    }
`

export const Card = styled.div`
    border-radius: 12px;
    padding: 20px;
    background: white;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
    word-break: break-word;
    
    @media (max-width: 768px) {
        padding: 16px;
    }
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--typography-h6-size);
  font-weight: 500;
  margin-bottom: 4px;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`

export const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  margin: 4px 0;
  font-size: 0.95rem;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const LocationIcon = styled(LocationOnOutlinedIcon)`
  color: #666;
`

export const PaymentTermsCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .payment-terms {
    font-weight: 700;
    margin: 4px 0;
  }

  .reminder {
    color: var(--info-main);
    text-decoration: underline;
    cursor: pointer;
    margin-top: 4px;
    
    @media (max-width: 768px) {
      margin-top: 2px;
    }
  }
`

export const ShiftDetailsCard = styled(Card)`
  .shift-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 12px 0;
    font-weight: 500;
    font-size: 1rem;
    
    &:first-child {
      margin-top: 0;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
    
    @media (max-width: 768px) {
      margin: 8px 0;
      font-size: 0.9rem;
      gap: 8px;
    }
  }

  .shift-row-title {
    font-weight: 700;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
`

export const NotificationBox = styled(Card)`
  display: flex;
  white-space: pre-line;
  flex-wrap: wrap;
  font-size: 0.95rem;
  line-height: 1.5;
  gap: 8px;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.4;
    padding: 16px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 8px 0 24px;
  
  @media (max-width: 768px) {
    gap: 10px;
    margin: 4px 0 16px;
  }
`

export const ActionButton = styled(Button)`
  &.MuiButton-root {
    border-radius: 8px;
    padding: 12px;
    width: 100%;
    text-transform: none;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    @media (max-width: 768px) {
      padding: 6px;
      font-size: 0.9rem;
      min-height: 32px;
    }

    &.outlined {
      border: 1px solid var(--primary-main);
      color: var(--primary-main);
    }

    &.contained {
      background-color: var(--primary-main);
      color: white;
    }
  }
`

export const RemoveButton = styled(ActionButton)`
  &.MuiButton-root {
    border: 1px solid var(--error-main) !important;
    color: var(--error-main) !important;
    background: none;

    &:hover {
      background: rgba(211, 47, 47, 0.04);
    }

    .MuiSvgIcon-root {
      color: var(--error-main) !important;
    }
  }
`

export const PaymentTermsTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 500;
  padding-bottom: 0.5rem;
`

export const AttachMoneyIcon = styled(AttachMoney)`
  color: var(--primary-green);
`

export const NotificationsOutlinedIcon = styled(NotificationsOutlined)`
  padding-right: 0.5rem;
  color: #ffcd4c;
  vertical-align: bottom;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    padding: 0.25rem 0.5rem 0.5rem 0;
  }
`

export const AccessTimeIcon = styled(AccessTime)`
  color: var(--primary-blue);
`

export const EventIcon = styled(Event)`
  color: var(--primary-blue);
`

export const ButtonIcon = styled.span`
  display: flex;
  align-items: center;

  &.error {
    color: var(--error-main);
  }
`